import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-long-arrow",
  "use": "icon-long-arrow-usage",
  "viewBox": "0 0 31.479 31.479",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31.479 31.479\" id=\"icon-long-arrow\"><path d=\"M26.485 21.206a1.14 1.14 0 0 0 0-1.587c-.444-.429-1.159-.429-1.587 0l-8.047 8.047V1.111C16.851.492 16.359 0 15.74 0s-1.127.492-1.127 1.111v26.555l-8.031-8.047a1.14 1.14 0 0 0-1.587 0 1.14 1.14 0 0 0 0 1.587l9.952 9.952a1.14 1.14 0 0 0 1.587 0l9.951-9.952z\" class=\"active-path\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol